export {default} from './CookieConsent'
